import React, {useMemo, useEffect} from 'react';
import {useMessages} from 'react-chatbotify';
import {useUserContext} from '../../contexts';

interface ChatRendererProps {
  newUserChat: React.ReactElement;
  returnedUserChat: React.ReactElement;
  noUserChat: React.ReactElement;
}

export const ChatManager = ({
                              newUserChat,
                              returnedUserChat,
                              noUserChat,
                            }: ChatRendererProps) => {
  const {user, answers} = useUserContext();
  const messages = useMessages();

  useEffect(() => {
    messages.replaceMessages([]);
  }, [user.contactID])

  return useMemo(() => {
    if (!user.contactID) {
      return noUserChat;
    } else if (answers.length === 0) {
      return newUserChat;
    } else {
      return returnedUserChat;
    }
  }, [user.contactID, answers.length]);
};